import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=06957e80&scoped=true&"
import script from "./TableLayout.vue?vue&type=script&lang=ts&"
export * from "./TableLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=06957e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06957e80",
  null
  
)

export default component.exports